import { type ServiceMethod } from '@/application/interfaces/service';

import { type UserResources } from './model';

export interface Response extends UserResources {}

const getUserResources: ServiceMethod<Response> =
  (httpClient) => async (options) => {
    const { body } = await httpClient.get<Response, undefined, undefined>(
      `/api/v1/user-resources`,
      options
    );

    return body;
  };

export default getUserResources;
